module.exports = __webpack_public_path__ + "html/change_my_password.f75d7b.html";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/User/change_my_password.html
 ** module id = 521
 ** module chunks = 0 1 2 3 5 11
 **/